export default __webpack_public_path__ + "static/media/app_animation.d38e9a67.mp4";